import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "shortcodes"
    }}>{`Shortcodes`}</h1>
    <p>{`Please remember one thing before using any shortcode that do not use the Gutenberg Editor instead use the Classic Mode.`}</p>
    <p><img alt="Short1.png" src={require("./images/Short1.png")} /></p>
    <h2 {...{
      "id": "intro"
    }}>{`Intro`}</h2>
    <p>{`There are plenty of short codes for you to build pages as you wish. You hold the full control.`}</p>
    <p><img alt="Short2.png" src={require("./images/Short2.png")} /></p>
    <p>{`There are some short codes which will contain elements as their child. Those are:`}</p>
    <ul>
      <li parentName="ul">{`Accordion`}</li>
      <li parentName="ul">{`Contact Us Page Address Bar`}</li>
      <li parentName="ul">{`Testimonial`}</li>
      <li parentName="ul">{`Our Partner`}</li>
      <li parentName="ul">{`Our Team`}</li>
      <li parentName="ul">{`How It Works etc.`}</li>
    </ul>
    <p>{`In Contact Us Page Address Bar, we have shown how to add child elements. Please follow this instruction for the short codes mentioned above.`}</p>
    <h2 {...{
      "id": "top-rated-products"
    }}>{`Top Rated Products`}</h2>
    <h3 {...{
      "id": "backend"
    }}>{`Backend:`}</h3>
    <p><img alt="Short3.png" src={require("./images/Short3.png")} /></p>
    <h3 {...{
      "id": "frontend"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="Short4.png" src={require("./images/Short4.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Note: Please Use Car Tabs shortcode instead this shortcode for better view and result.`}</p>
    </blockquote>
    <h2 {...{
      "id": "content-blocks"
    }}>{`Content Blocks`}</h2>
    <h3 {...{
      "id": "backend-1"
    }}>{`Backend:`}</h3>
    <p><img alt="1import.png" src={require("./images/1import.png")} />{`
`}<img alt="2import.png" src={require("./images/2import.png")} />{`
`}<img alt="3import.png" src={require("./images/3import.png")} /></p>
    <h3 {...{
      "id": "frontend-1"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="4import.png" src={require("./images/4import.png")} /></p>
    <h2 {...{
      "id": "featured-blocks"
    }}>{`Featured Blocks`}</h2>
    <h3 {...{
      "id": "backend-2"
    }}>{`Backend:`}</h3>
    <p><img alt="5import.png" src={require("./images/5import.png")} /></p>
    <h4 {...{
      "id": "layout-3"
    }}>{`Layout 3`}</h4>
    <p><img alt="6import.png" src={require("./images/6import.png")} /></p>
    <h4 {...{
      "id": "layout-4"
    }}>{`Layout 4`}</h4>
    <p><img alt="7import.png" src={require("./images/7import.png")} />{`
`}<img alt="8import.png" src={require("./images/8import.png")} /></p>
    <h3 {...{
      "id": "frontend-2"
    }}>{`FrontEnd:`}</h3>
    <h4 {...{
      "id": "layout-3-1"
    }}>{`Layout 3`}</h4>
    <p><img alt="9import.png" src={require("./images/9import.png")} /></p>
    <h4 {...{
      "id": "layout-4-1"
    }}>{`Layout 4`}</h4>
    <p><img alt="11import.png" src={require("./images/11import.png")} /></p>
    <h2 {...{
      "id": "recent-products"
    }}>{`Recent Products`}</h2>
    <h3 {...{
      "id": "backend-3"
    }}>{`Backend:`}</h3>
    <p><img alt="RPB.png" src={require("./images/RPB.png")} /></p>
    <h3 {...{
      "id": "frontend-3"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="RPF.png" src={require("./images/RPF.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Note: Please Use Car Tabs shortcode instead this shortcode for better view and result.`}</p>
    </blockquote>
    <h2 {...{
      "id": "testimonial"
    }}>{`Testimonial`}</h2>
    <h3 {...{
      "id": "backend-4"
    }}>{`Backend:`}</h3>
    <p><img alt="16import.png" src={require("./images/16import.png")} />{`
`}<img alt="17import.png" src={require("./images/17import.png")} />{`
`}<img alt="18import.png" src={require("./images/18import.png")} />{`
`}<img alt="19import.png" src={require("./images/19import.png")} />{`
`}<img alt="20import.png" src={require("./images/20import.png")} /></p>
    <h3 {...{
      "id": "frontend-4"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="21import.png" src={require("./images/21import.png")} /></p>
    <h2 {...{
      "id": "tips--tricks"
    }}>{`Tips & Tricks`}</h2>
    <h3 {...{
      "id": "backend-5"
    }}>{`Backend:`}</h3>
    <p><img alt="22import.png" src={require("./images/22import.png")} />{`
`}<img alt="23import.png" src={require("./images/23import.png")} /></p>
    <h3 {...{
      "id": "frontend-5"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="24import.png" src={require("./images/24import.png")} /></p>
    <h2 {...{
      "id": "help-line"
    }}>{`Help Line`}</h2>
    <h3 {...{
      "id": "backend-6"
    }}>{`Backend:`}</h3>
    <p><img alt="25import.png" src={require("./images/25import.png")} /></p>
    <h3 {...{
      "id": "frontend-6"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="26import.png" src={require("./images/26import.png")} /></p>
    <h2 {...{
      "id": "our-mission"
    }}>{`Our Mission`}</h2>
    <h3 {...{
      "id": "backend-7"
    }}>{`Backend:`}</h3>
    <p><img alt="27import.png" src={require("./images/27import.png")} /></p>
    <h3 {...{
      "id": "frontend-7"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="28import.png" src={require("./images/28import.png")} /></p>
    <h2 {...{
      "id": "our-partner"
    }}>{`Our Partner`}</h2>
    <h3 {...{
      "id": "backend-8"
    }}>{`Backend:`}</h3>
    <p><img alt="29import.png" src={require("./images/29import.png")} /></p>
    <h3 {...{
      "id": "frontend-8"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="30import.png" src={require("./images/30import.png")} /></p>
    <h2 {...{
      "id": "horizontal-search-form"
    }}>{`Horizontal Search Form`}</h2>
    <h3 {...{
      "id": "backend-9"
    }}>{`Backend:`}</h3>
    <p><img alt="31import.png" src={require("./images/31import.png")} /></p>
    <h4 {...{
      "id": "layout-3-2"
    }}>{`Layout 3`}</h4>
    <p><img alt="32import.png" src={require("./images/32import.png")} />{`
`}<img alt="33import.png" src={require("./images/33import.png")} /></p>
    <h4 {...{
      "id": "layout-4-2"
    }}>{`Layout 4`}</h4>
    <p><img alt="34import.png" src={require("./images/34import.png")} />{`
`}<img alt="35import.png" src={require("./images/35import.png")} /></p>
    <h3 {...{
      "id": "frontend-9"
    }}>{`FrontEnd:`}</h3>
    <h4 {...{
      "id": "layout-3-3"
    }}>{`Layout 3`}</h4>
    <p><img alt="36import.png" src={require("./images/36import.png")} /></p>
    <h4 {...{
      "id": "layout-4-3"
    }}>{`Layout 4`}</h4>
    <p><img alt="37import.png" src={require("./images/37import.png")} /></p>
    <h2 {...{
      "id": "vertical-search-form"
    }}>{`Vertical Search Form`}</h2>
    <p><img alt="VSF.png" src={require("./images/VSF.png")} /></p>
    <h2 {...{
      "id": "about-contact-info"
    }}>{`About Contact Info`}</h2>
    <p><img alt="ACI.png" src={require("./images/ACI.png")} /></p>
    <h2 {...{
      "id": "about-contact-info-1"
    }}>{`About Contact Info`}</h2>
    <p><img alt="OT.png" src={require("./images/OT.png")} /></p>
    <h2 {...{
      "id": "the-brand"
    }}>{`The Brand`}</h2>
    <h3 {...{
      "id": "backend-10"
    }}>{`Backend:`}</h3>
    <p><img alt="38import.png" src={require("./images/38import.png")} /></p>
    <h3 {...{
      "id": "frontend-10"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="39import.png" src={require("./images/39import.png")} /></p>
    <h2 {...{
      "id": "contact-details"
    }}>{`Contact details`}</h2>
    <p>{`Contact details will look like this:`}</p>
    <p><img alt="40import.png" src={require("./images/40import.png")} /></p>
    <p>{`To achieve this block use "Contact Us Page Address Bar" shortcode. Insert child elements. Then fill up the fields. You are ready to go. :)`}</p>
    <p><img alt="41import.png" src={require("./images/41import.png")} /></p>
    <h2 {...{
      "id": "popular-cars"
    }}>{`Popular Cars`}</h2>
    <h3 {...{
      "id": "backend-11"
    }}>{`Backend:`}</h3>
    <p><img alt="42import.png" src={require("./images/42import.png")} /></p>
    <h3 {...{
      "id": "frontend-11"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="43import.png" src={require("./images/43import.png")} /></p>
    <h2 {...{
      "id": "feature-block-holder"
    }}>{`Feature Block Holder`}</h2>
    <h3 {...{
      "id": "backend-12"
    }}>{`Backend:`}</h3>
    <p><img alt="FT.png" src={require("./images/FT.png")} /></p>
    <h3 {...{
      "id": "frontend-12"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="68import.png" src={require("./images/68import.png")} /></p>
    <h2 {...{
      "id": "download-app"
    }}>{`Download App`}</h2>
    <h3 {...{
      "id": "backend-13"
    }}>{`Backend:`}</h3>
    <p><img alt="44import.png" src={require("./images/44import.png")} /></p>
    <h3 {...{
      "id": "frontend-13"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="45import.png" src={require("./images/45import.png")} /></p>
    <h2 {...{
      "id": "single-content-block"
    }}>{`Single Content Block`}</h2>
    <h3 {...{
      "id": "backend-14"
    }}>{`Backend:`}</h3>
    <p><img alt="46import.png" src={require("./images/46import.png")} />{`
`}<img alt="47import.png" src={require("./images/47import.png")} /></p>
    <h3 {...{
      "id": "frontend-14"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="48import.png" src={require("./images/48import.png")} /></p>
    <h2 {...{
      "id": "news-letter"
    }}>{`News Letter`}</h2>
    <h3 {...{
      "id": "backend-15"
    }}>{`Backend:`}</h3>
    <p><img alt="49import.png" src={require("./images/49import.png")} /></p>
    <h3 {...{
      "id": "frontend-15"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="50import.png" src={require("./images/50import.png")} /></p>
    <h2 {...{
      "id": "buttons"
    }}>{`Buttons`}</h2>
    <h3 {...{
      "id": "backend-16"
    }}>{`Backend:`}</h3>
    <p><img alt="51import.png" src={require("./images/51import.png")} /></p>
    <h3 {...{
      "id": "frontend-16"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="52import.png" src={require("./images/52import.png")} /></p>
    <h2 {...{
      "id": "fact-boxes"
    }}>{`Fact Boxes`}</h2>
    <h3 {...{
      "id": "backend-17"
    }}>{`Backend:`}</h3>
    <p><img alt="53import.png" src={require("./images/53import.png")} /></p>
    <h3 {...{
      "id": "frontend-17"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="54import.png" src={require("./images/54import.png")} /></p>
    <h2 {...{
      "id": "fact-boxes-1"
    }}>{`Fact Boxes`}</h2>
    <h3 {...{
      "id": "backend-18"
    }}>{`Backend:`}</h3>
    <p><img alt="55import.png" src={require("./images/55import.png")} /></p>
    <h3 {...{
      "id": "frontend-18"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="56import.png" src={require("./images/56import.png")} /></p>
    <h2 {...{
      "id": "progress-bar"
    }}>{`Progress Bar`}</h2>
    <h3 {...{
      "id": "backend-19"
    }}>{`Backend:`}</h3>
    <p><img alt="57import.png" src={require("./images/57import.png")} /></p>
    <h3 {...{
      "id": "frontend-19"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="58import.png" src={require("./images/58import.png")} /></p>
    <h2 {...{
      "id": "circular-progress-bar"
    }}>{`Circular Progress Bar`}</h2>
    <h3 {...{
      "id": "backend-20"
    }}>{`Backend:`}</h3>
    <p><img alt="59import.png" src={require("./images/59import.png")} /></p>
    <h3 {...{
      "id": "frontend-20"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="60import.png" src={require("./images/60import.png")} /></p>
    <h2 {...{
      "id": "accordions"
    }}>{`Accordions`}</h2>
    <p>{`For this block, first choose 'Accordions' shortcode. Then add elements as child of this shortcode. Please note that you have to provide unique id for each accordion element.`}</p>
    <h3 {...{
      "id": "backend-21"
    }}>{`Backend:`}</h3>
    <p><img alt="62import.png" src={require("./images/62import.png")} /></p>
    <h3 {...{
      "id": "frontend-21"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="61import.png" src={require("./images/61import.png")} /></p>
    <h2 {...{
      "id": "google-map"
    }}>{`Google Map`}</h2>
    <h3 {...{
      "id": "backend-22"
    }}>{`Backend:`}</h3>
    <p><img alt="63import.png" src={require("./images/63import.png")} /></p>
    <h3 {...{
      "id": "frontend-22"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="64import.png" src={require("./images/64import.png")} /></p>
    <h2 {...{
      "id": "fancy-title"
    }}>{`Fancy Title`}</h2>
    <h3 {...{
      "id": "backend-23"
    }}>{`Backend:`}</h3>
    <p><img alt="1FT.png" src={require("./images/1FT.png")} /></p>
    <h2 {...{
      "id": "featured-product"
    }}>{`Featured Product`}</h2>
    <h3 {...{
      "id": "backend-24"
    }}>{`Backend:`}</h3>
    <p><img alt="65import.png" src={require("./images/65import.png")} />{`
`}<img alt="66import.png" src={require("./images/66import.png")} /></p>
    <h3 {...{
      "id": "frontend-23"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="67import.png" src={require("./images/67import.png")} /></p>
    <h2 {...{
      "id": "filter-result"
    }}>{`Filter Result`}</h2>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/g0DqhtwxqHU"
      }}>{`You can watch the video below to know more about the settings of the listing page.`}</a></p>
    <h3 {...{
      "id": "backend-25"
    }}>{`Backend:`}</h3>
    <p><img alt="listing-back-image-1.png" src={require("./images/listing/listing-back-image-1.png")} />{`
`}<img alt="listing-back-image-2.png" src={require("./images/listing/listing-back-image-2.png")} />{`
`}<img alt="listing-back-image-3.png" src={require("./images/listing/listing-back-image-3.png")} />{`
`}<img alt="listing-back-image-4.png" src={require("./images/listing/listing-back-image-4.png")} /></p>
    <h3 {...{
      "id": "frontend-24"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="listing-frontend.png" src={require("./images/listing/listing-frontend.png")} /></p>
    <h2 {...{
      "id": "home-search-form"
    }}>{`Home Search Form`}</h2>
    <h3 {...{
      "id": "backend-26"
    }}>{`Backend:`}</h3>
    <p><img alt="home-search-form-back-1" src={require("./images/home-search-form/home-search-form-back-1.png")} />{`
`}<img alt="home-search-form-back-2" src={require("./images/home-search-form/home-search-form-back-2.png")} />{`
`}<img alt="home-search-form-back-3" src={require("./images/home-search-form/home-search-form-back-3.png")} />{`
`}<img alt="home-search-form-back-4" src={require("./images/home-search-form/home-search-form-back-4.png")} /></p>
    <h3 {...{
      "id": "frontend-25"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="home-search-form-front-2" src={require("./images/home-search-form/home-search-form-front-2.png")} />{`
`}<img alt="home-search-form-front-1" src={require("./images/home-search-form/home-search-form-front-1.png")} />{`
`}<img alt="home-search-form-front-3" src={require("./images/home-search-form/home-search-form-front-3.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      